import React, { FunctionComponent } from "react";
import { Link } from "react-router-dom";
import "./BackButton.scss";

export interface BackButtonProps {
  url?: string;
}

const BackButton: FunctionComponent<BackButtonProps> = ({ url }) => {
  return <Link className="back-button" to={url ? url : ""}></Link>;
};

export default BackButton;
